
import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
// import { BASE } from '../api/api'
import Axios from 'axios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import './search.css'
import Loader from 'react-loader'
import search from '../assets/search.png'
import load from '../assets/loading.gif'
import ReactGA from 'react-ga';
import printJS from 'print-js';
import Highlighter from "react-highlight-words";
import queryString from 'query-string'
import ReactHtmlParser from 'react-html-parser';
ReactGA.initialize('UA-139161970-1');
export const BASE = 'https://ibir-api.hbku.edu.qa/';
class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            keyword: props.match.params.id ? props.match.params.id : '',
            currentid: props.match.params.id ? props.match.params.id : '',
            xxx: props.match.params.filter ? props.match.params.filter : '',
            filters: 'f[0]=type:submit_for_work&f[1]=type:project&f[2]=type:events',
            filterhide: "",
            result: '',
            index: -1,
            news: '',
            people: '',
            books: '',
            notxt: "",
            load: false,
            search_filters_arr: [],
            redirect: false,
            fpopup: false,
            page: new URL(window.location.href).searchParams.get("start") ? 1 : 0,
            authorkeys: [],
            journkey: '',
            affkey: '',
            authkey: '',
            prev: false,
            cisnid: new URL(window.location.href).searchParams.get("start") ? true : null,
            next: false,
            start: new URL(window.location.href).searchParams.get("start") ? 20 : 0,
            advance: false,
            advancearray: [],
            advanceopt: [],
            advancekey: '',
            exportid: [],
            mailpdf: '',
            login: false,
            loginred: props.location.pathname,
            size: 20,
            loader: props.match.params.id ? true : false,
            cislength: 0,
            jjj: new URL(window.location.href).searchParams.get("filter") ? new URL(window.location.href).searchParams.get("filter") : 0
        }
        console.log(this.state.xxx, 'xxx')
    }




    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    componentDidMount() {
        ReactGA.pageview('/search/' + this.state.keyword);
        console.log(this.state.jjj, 'jjj')
    }


    componentWillMount() {
        this.getrelfil()
        let login = localStorage.getItem('token');
        if (login && login != null) {
            this.setState({
                login: true
            })
        }

        // window.addEventListener("storage", function () {
        //     let login = localStorage.getItem('token');
        //     if (login && login != null) {
        //         // this.setState({
        //         //     login: true
        //         // })
        //         // this.alert("logiiinhei")
        //     }

        // }, false);


        localStorage.removeItem('search');
        this.topFunction()
        let url = window.location.href;
        let url_string = url;
        let urlStr = new URL(url_string);
        let c = this.state.keyword;
        let filter = new URLSearchParams(this.props.location.search).get("type")
        console.log("filter start", filter)
        let f = urlStr.searchParams.get("filter")
        this.setState({
            keyword: c ? c : '',
        })
        if (filter) {
            this.checkDefaultFilterCombination()
            if (filter === "events" || filter === "project") {
                this.setFilter(`type:${filter}`)
            }
            else {
                this.setFilter(`publications:${filter}`)
            }
        }
        else
            if (c) {
                this.search(c, this.state.filters, this.state.page * this.state.size, this.state.size);
            }
    }

    print(op, mail) {
        if (op === "save" || op === "print") {

        }
        else {

        }
        if (this.state.exportid.length !== 0) {

            const formbody = {
                "email": mail,
                "operation": op === "save" || op === "print" ? "save" : op,
                "id": '[' + this.state.exportid.join() + ']'
            }
            this.setState({
                load: true
            })

            Axios(BASE + 'notification/export', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                data: formbody
            })

                .then((res) => {

                    console.log(res)
                    if (op === "save") {
                        this.setState({
                            load: false,
                            exportid: [],
                            selectall: false
                        })
                        window.open('http://' + res.data, "_self")
                        // window.open('http://'+res.data)

                    }
                    else if (op === "print") {
                        setTimeout(
                            function () {
                                this.setState({ load: false });
                            }
                                .bind(this),
                            5000
                        );

                        printJS('http://' + res.data)
                        this.setState({
                            exportid: [],
                            selectall: false
                        })
                    }
                    else
                        this.fillalert('Mail Sent')
                    this.setState({
                        mailpop: false,
                        load: false,
                        exportid: [],
                        selectall: false,
                        mailpdf: ''
                    })
                })
                .catch((err) => {
                    console.log(err)
                    this.fillalert('Please enter valid details')

                })

        }
        else {
            if (op === "save")
                this.fillalert('Select some results to Save')
            else {
                this.fillalert('Select some results to Print')

            }
        }
    }

    openpopmail() {
        if (this.state.exportid.length !== 0) {
            if (this.state.exportid.length > 25) {
                this.fillalert("Cannot mail more than 25 records!")
            }
            else {
                this.setState({
                    mailpop: !this.state.mailpop,
                    advance: false,
                    advancearray: []
                })
            }
        }
        else
            this.fillalert('Select some results to Mail')
    }


    printTest2(op, mail) {

        if (op === "mail") {
            {
                if (this.state.exportid.length > 25) {
                    this.fillalert("Cannot mail more than 25 records!")
                }

                else {
                    let ere = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}")
                    if (mail) {
                        if (ere.test(mail) == true)
                            this.print(op, mail)
                        else
                            this.fillalert('Please enter a valid Email ID')
                    }
                    else
                        this.fillalert('Please enter the Email ID')
                }
            }

        }
        else {
            if (this.state.exportid.length > 50) {
                this.fillalert("Cannot print/download more than 50 records!")
            }
            else
                this.print(op, "dummy")
        }

    }

    exportmail(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }



    checkexport(id) {
        let dt = this.state.exportid.indexOf(id)
        if (dt > -1) {
            return true
        }
        else {
            return false
        }
    }

    exportid(id) {
        let exportid = this.state.exportid
        let dt = this.state.exportid.indexOf(id)
        if (dt > -1) {
            exportid.splice(dt, 1);
        }
        else {
            exportid.push(id)
        }
        this.setState({
            exportid: exportid
        })
        console.log(exportid, 'export')
    }


    deladvacnearray(id) {
        console.log(this.state.advancearray, 'advance')
        console.log(this.state.advanceopt, 'advance')

        let advancearray = this.state.advancearray
        advancearray.splice(id, 1);
        this.setState({
            advancearray: advancearray
        })
        let advanceopt = this.state.advanceopt
        advanceopt.splice(id, 1);
        this.setState({
            advanceopt: advanceopt
        })
        if (advancearray.length === 0) {
            this.setState({
                advance: false
            })
        }

        let i
        let keywordarray = [this.state.keyword]
        // let newadvancearray=keywordarray.concat(this.state.advancearray)
        for (i = 0; i < this.state.advanceopt.length; i++) {
            if (this.state.advancearray[i]) {
                var regex = /^(?:[a-zA-Z0-9\s'()"\u0600-\u06FF]){0,30}$/;
                let newarr2 = this.state.advancearray[i].replace(/,/g, "").replace(/[()]/g, '').split('.').join(" ")
                let newarr = newarr2.replace(/-/g, " ").replace(/\//g, ' ').replace('/', ' ').split(' ')
                let len = newarr.length
                for (let j = 0; j < len; j++) {
                    console.log(newarr, "advance")
                    if (regex.test(newarr[j]) && newarr[j] !== "") {
                        keywordarray.push(this.state.advanceopt[i])
                        keywordarray.push(newarr[j])
                    }
                }
            }
        }
        console.log(keywordarray.join(' '), "advance")
        this.setState({
            advancekey: keywordarray.length !== 0 ? keywordarray.join(' ') : ''
        })
    }

    keychange(e, index, key) {
        if (e.target.name !== "keyword") {
            if (e.target.name === "advancekey") {
                let advancearray = this.state.advancearray
                advancearray[index] = e.target.value
                this.setState({
                    advancearray: advancearray
                })
            }
            else {
                let advanceopt = this.state.advanceopt
                advanceopt[index] = e.target.value
                this.setState({
                    advanceopt: advanceopt
                })
            }
        }

        let i
        let keywordarray = [key ? key : this.state.keyword]
        for (i = 0; i < this.state.advanceopt.length; i++) {
            if (this.state.advancearray[i]) {
                var regex = /^(?:[a-zA-Z0-9\s'()"\u0600-\u06FF]){0,30}$/;
                let newarr2 = this.state.advancearray[i].replace(/,/g, "").replace(/[()]/g, '').split('.').join(" ")
                let newarr = newarr2.replace(/-/g, " ").replace(/\//g, ' ').replace('/', ' ').split(' ')
                let len = newarr.length
                for (let j = 0; j < len; j++) {
                    console.log(newarr, "advance")
                    if (regex.test(newarr[j]) && newarr[j] !== "") {
                        keywordarray.push(this.state.advanceopt[i])
                        keywordarray.push(newarr[j])
                    }
                }
            }
        }
        console.log(keywordarray.join(' '), "advance")
        this.setState({
            advancekey: keywordarray.join(' ')
        })
    }


    openadvance() {
        if (!this.state.advance) {
            this.addadvancearray()
        }
        else {
            this.setState({
                advancearray: [],
                advanceopt: [],
                advancekey: ''
            })

        }
        this.setState({
            advance: !this.state.advance,
            mailpop: false
        })
    }

    addadvancearray(index) {
        if (this.state.advancearray[index] || !this.state.advance) {
            let advancearray = this.state.advancearray
            advancearray.push("")
            this.setState({
                advancearray: advancearray
            })

            let advanceopt = this.state.advanceopt
            advanceopt.push("AND")
            this.setState({
                advanceopt: advanceopt
            })
        }
        else {
            this.fillalert('Empty Field')
        }
    }

    getrelfil() {
        let cf2 = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword
        let cf1 = cf2.split('.').join(" ")
        let cf = this.staradd(cf1).replace(/[()]/g, '').replace(/\//g, "-").replace(/,/g, "")
        console.log(cf, BASE + 'api/search?Keyword=' + cf + '&from=0&size=1', 'resultagg')
        Axios.get(BASE + 'api/search?Keyword=' + cf + '&from=0&size=1')
            .then((data) => {

                console.log(data.data.aggregations, 'resultagg')
                this.setState({
                    relfil: data.data.aggregations,
                    journal: data.data.aggregations.journal_label.buckets,
                    affiliation: data.data.aggregations.affliations_label.buckets,
                    authorlist: data.data.aggregations.authors_label.buckets
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }


    gotologin() {
        let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword

        //this.props.history.push('/search/' + cf + '?start=20')
    }

    signout(id) {
        let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword

        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        if (!id)
            this.props.history.push('/search/' + cf + '?start=20')
        else
            this.props.history.push('/search/' + cf)

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry(id) {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.fillalert('Session Expired!Logging Out')
                this.signout(id)
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.fillalert('Session Expired!Logging Out')
            this.signout(id)

        }
    }

    //   componentWillMount(){
    //     if(this.state.token)
    //         this.checkexpiry()
    //   }

    handlePageClick = data => {
        // if (!this.state.login) {
        //     this.gotologin()
        // }
        // else {
        //     this.checkexpiry()
        // }
        // this.setState({
        //     selectall: false
        // })
        console.log("filter on next", this.state.filters)
        if (data === 'next' && this.state.next === true) {
            // this.setState({
            //     result: '',
            // })

            this.search(this.state.keyword, this.state.filters, this.state.start + this.state.size, this.state.size)
            this.setState({
                start: this.state.start + this.state.size
            })

        }
        else if (data === 'prev' && this.state.prev === true) {
            // this.setState({
            //     result: '',
            // })
            this.search(this.state.keyword, this.state.filters, this.state.start - this.state.size, this.state.size)
            this.setState({
                start: this.state.start - this.state.size
            })
        }


    };




    componentWillReceiveProps(nextProps) {
        this.setState({
            result: '',
            keyword: nextProps.match.params.id
        })
        // if (this.state.previouskey) {
        //     if (this.state.previouskey !== nextProps.match.params.id) {
        //         this.setState({
        //             keyword: nextProps.match.params.id,
        //             // result: '',
        //             currentid: nextProps.match.params.id,
        //             // loader: true,
        //             previouskey: nextProps.match.params.id
        //         })
        if (nextProps.match.params.id !== this.props.match.params.id)
            this.search(nextProps.match.params.id, this.state.filters, 0, this.state.size, 'proppass')
        //         // this.getrelfil()
        //     }
        // }
        // else {
        //     this.setState({
        //         keyword: nextProps.match.params.id,
        //         // result: '',
        //         currentid: nextProps.match.params.id,
        //         previouskey: nextProps.match.params.id
        //     })
        // this.search(nextProps.match.params.id, 'f[0]=type:submit_for_work', 0, this.state.size)
        // this.getrelfil()

    }



    handleChange = (e) => {
        if (e.target.name === 'keyword') {
            this.setState({
                start: 0
            })
            this.keychange(e, '', e.target.value)
            // if (this.state.keyword === '') {
            //     this.setState({
            //         result: ''
            //     })
            // }
            // localStorage.setItem('searched', e.target.value)
        }
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    _handleKeyPress2(e) {
        if (e.key === 'Enter') {
            console.log(this.state.advancearray, "heii", this.state.advancekey)
            let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword

            if (this.state.currentkey !== cf)
                this.handleSubmit()
        }
    }
    _handleKeyPress(e) {
        // alert(e.key)
        if (e.key === 'Enter') {
            //alert('hi')
            if (this.state.keyword.length < 3) {
                this.fillalert("Enter atleast 3 characters")
            }
            else {
                let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword

                if (this.state.currentkey !== cf)
                    this.handleSubmit();

            }
        }
        else {
            console.log("not enter")
        }
    }
    dividequotes(word) {
        // alert(word)
        let cf44 = []
        var regex = /^(?:[a-zA-Z0-9\s',()"\u0600-\u06FF]){0,30}$/;
        // console.log(word,'unix')
        // let cf22 = word.match(/\w+|"[^"]+"/g)
        let cf33 = word.replace(',', '%20').replace(/-/g, " ").replace(/[()]/g, '').replace(',', '%20').split(' ')
        for (let i = 0; i < cf33.length; i++) {
            var word1 = cf33[i]
            if (regex.test(word1) && word1 !== "") {
                if (word1[word1.length - 1] === '\'') {
                    cf44.push(word.slice(0, -1))
                }
                else
                    cf44.push(word1)
            }
        }

        console.log(cf44, "unix1", cf33)
        return cf44
    }

    // dividequotes(word) {
    //     let cf44 = []
    //     let cf22 = word.match(/\w+|"[^"]+"/g)
    //     //     for (i = 0; i < cf22.length; i++) {
    //     //     cf44.push(cf22[i].replace(/"/g,""))
    //     // }
    //     console.log(cf22, "divide")
    //     return cf22
    // }

    store() {
        localStorage.setItem('searchkey', JSON.stringify(this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword))
        let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword
        let keyarr4 = []
        if (cf) {
            console.log(cf.match(/\w+|"[^"]+"/g), "high223")
            let keyarr1 = cf
            let keyarr = keyarr1.replace(/AND|NOT|OR/g, "");
            let keyarr3 = keyarr.split(" ")
            for (let i = 0; i < keyarr3.length; i++) {
                keyarr4.push(keyarr3[i].replace(/['"]+/g, ''))
            }
            // alert('hi')
            // keyarr.split(" ")
            console.log(keyarr.split(" "), "0909")
            let i, sarray = []
            for (i = 0; i < this.state.result.length; i++) {
                sarray.push(this.state.result[i]._source.nid[0])
            }
            localStorage.setItem('sarray', JSON.stringify(sarray))
            localStorage.setItem('keyarr', JSON.stringify(this.state.highwords))
            localStorage.setItem('sfilter', JSON.stringify(this.state.filters))
            localStorage.setItem('sstart', JSON.stringify(this.state.start))
            localStorage.setItem('ssize', JSON.stringify(this.state.size))
        }
    }

    searchbuttonpress() {
        window.location.href = '/search/' + this.state.keyword
    }

    //setting author length
    bio(title, nid) {
        return '/content/' + title + '/author_nodes/' + nid
    }

    //setting the link to address
    goto2(nid, name, title) {
        if (name != undefined)
            this.store()
        return '/publication/' + nid + '?search=true'

    }

    fillalert(msg) {
        this.topFunction()
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }

    getwords(word1) {
        console.log(word1, "regex2")
        let keyarr2 = word1.replace(/[\u201C\u201D]/g, '"')
        let keyarr1 = keyarr2
        let keyarr = keyarr1.replace(/AND|NOT|OR/g, "");
        console.log(keyarr.split(" "), "0909")
        let i, sarray = []
        sarray = keyarr.split(" ")
        var filtered = sarray.filter(function (el) {
            return el != "";
        });
        this.setState({
            highwords: filtered
        })
        console.log(keyarr, filtered, "highxz")
    }

    handleSubmit = () => {
        if (this.state.keyword.length < 3) {
            this.fillalert("Enter atleast 3 characters")
        }
        else {
            this.setState({
                filters: 'f[0]=type:submit_for_work',
                search_filters_arr: ['type:submit_for_work'],
                start: 0,
                prev: false,
                next: false,
                currentid: this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword,
                // result: ''
            })
            let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword

            if (this.state.currentkey !== cf) {
                localStorage.setItem('searched', this.state.keyword)
                this.props.history.push({
                    pathname: '/search/' + this.state.keyword.replace(/\//g, '%20')
                    // search: '?filter=' + this.state.filters
                })
                // this.search(cf, 'f[0]=type:submit_for_work', 0, this.state.size);
            }
        }

    }

    cisresult(c, f, p, s, set) {

        if (p === 0) {
            this.setState({
                prev: false
            })
        }
        else {
            this.setState({
                prev: true
            })
        }
        if (c) {
            if (c.length > 2) {
                this.setState({
                    result: '',
                    loader: true
                })
                let size = s ? s : this.state.size
                let cf2 = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : set ? c : this.state.keyword
                let cf1 = cf2.split('.').join(" ")
                let cf = this.staradd(cf1).replace(/\//g, "-").replace(/,/g, "")

                console.log(cf, "advance")
                // if (cf1 !== this.props.match.params.id) {
                // if (set !== 'setfil') {
                //     }
                // }

                console.log(BASE + 'api/search?Keyword=' + cf + '&from=' + p + '&size=' + size + '&' + f, 'urlax', this.state.advancearray)
                console.log("calling api in cisresult")
                Axios(BASE + 'api/cis_publication?Keyword=' + cf + '&' + f, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                })
                    .then((data) => {
                        let cisdata1 = data.data.hits.hits
                        console.log(data, 'cispublication')
                        console.log(this.state.result, 'countxx')
                        this.setState({
                            // result: data.data.hits.hits,
                            cislength: data.data.hits.hits.length
                        })
                        let i
                        let newsize = size - data.data.hits.hits.length
                        let cisnid = []
                        let cisstring = []
                        for (i = 0; i < data.data.hits.hits.length; i++) {
                            cisnid.push(data.data.hits.hits[i]._source.nid[0])
                            cisstring.push(`"entity:node/${data.data.hits.hits[i]._source.nid[0]}:${data.data.hits.hits[i]._source._language}"`)

                            // cisstring.push(data.data.hits.hits[i].id)
                        }
                        console.log(cisstring, 'cisnid')
                        this.setState({
                            cisnid: cisnid,
                            cisstring: cisstring.join(',')
                        })

                        localStorage.setItem('cisarray', JSON.stringify(cisnid))
                        localStorage.setItem('cisstring', JSON.stringify(cisstring))
                        console.log("filters", f)
                        // MAIN SEARCH
                        console.log(BASE + 'api/search?Keyword=' + cf + '&from=' + p + '&size=' + newsize + '&' + f + '&exclude=[' + cisstring.join(',') + ']', 'urlax in')
                        console.log("filter used", f)
                        let used = f ? f : "f[0]=type:submit_for_work&f[1]=type:project&f[2]=type:events"
                        Axios(BASE + 'api/search?Keyword=' + cf + '&from=' + p + '&size=' + newsize + '&' + used + '&exclude=[' + cisstring.join(',') + ']', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        })
                            .then((data) => {
                                this.topFunction()
                                if (p === 0 && this.state.filters === 'f[0]=type:submit_for_work&f[1]=type:project&f[2]=type:events')
                                    this.getrelfil()
                                console.log(data, 'unix2')
                                console.log(cisdata1.concat(data.data.hits.hits), 'unix2')
                                this.setState({
                                    result: cisdata1.concat(data.data.hits.hits),
                                    total: data.data.hits.total.value,
                                    loader: false
                                    // relfil:data.data.aggregations,
                                    // journal:data.data.aggregations.journal_label.buckets,
                                    // affiliation:data.data.aggregations.affliations_label.buckets,
                                    // authorlist:data.data.aggregations.authors_label.buckets
                                })
                                if (data.data.hits.hits.length === 0) {
                                    this.setState({
                                        notxt: "No results found for  "

                                    })
                                }
                                else {
                                    this.setState({
                                        notxt: ''
                                    })
                                    let page = Number(size) + p - this.state.cislength
                                    this.checkpage(cf, f, page, newsize)

                                }
                            })
                            .catch((err) => {
                                console.log('err')
                            })
                        Axios(BASE + 'api/search?Keyword=' + cf + '&from=0' + '&size=' + size + '&' + `f[0]=type:project` + '&exclude=[' + this.state.cisstring + ']', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        })
                            .then(project => {
                                console.log("project found", project.data)
                                this.setState({
                                    projectTotal: project.data.hits.total.value,
                                })
                            })
                            .catch((err) => {
                                console.log('err')
                            })
                        Axios(BASE + 'api/search?Keyword=' + cf + '&from=0' + '&size=' + size + '&' + `f[0]=type:events` + '&exclude=[' + this.state.cisstring + ']', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        })
                            .then(event => {
                                console.log("project found", event.data)
                                this.setState({
                                    eventTotal: event.data.hits.total.value,
                                })
                            })
                            .catch((err) => {
                                console.log('err')
                            })
                    })
                console.log(BASE + 'api/search?Keyword=' + cf + '&from=' + p + '&size=' + size + '&' + f, 'xxx')
            }
        }
    }

    staradd(words) {
        if (words) {
            let searchword = this.dividequotes(words.replace(/[\u201C\u201D]/g, '"'))
            console.log(this.dividequotes(words.replace(/[\u201C\u201D]/g, '"')), "divide2")

            // searchword = words.replace(/\s\s+/g, ' ').trim().split(' ')
            let len = searchword.length
            if (searchword != '') {
                for (let i = 0; i < len; i++) {
                    if (searchword[i].includes('"')) {
                        searchword[i] = searchword[i].replace(/["]+/g, '')
                    }
                    else {
                        if (searchword[i] === "AND" || searchword[i] === "NOT" || searchword[i] === "OR")
                            searchword[i] = searchword[i]
                        else
                            searchword[i] = searchword[i] + '*'
                    }
                }
            }
            console.log(searchword.join(' '), "divide3")
            return searchword.join(' ')
        }
        else
            return ''

    }

    checklogin() {
        let dt = localStorage.getItem('token')
        if (!dt || dt == null) {
            let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword
            window.location.href = '/search/' + cf + '?start=20'
        }
        else
            return true
    }

    search(c, f, p, s, set) {
        localStorage.setItem('searched', c)
        console.log(this.state.advancearray, "minx")
        let word1 = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword
        console.log(this.state.advancekey, "numb")
        console.log("p in search", p)
        if (!this.state.advancekey) {
            this.deladvacnearray(0)
        }
        this.setState({
            from: p
        })
        console.log("filters", f)
        // if (word1 !== this.state.currentkey || p !== this.state.currepage || f !== this.state.filters) {
        //     this.setState({
        //         currentkey: word1,
        //         currepage: p,
        //         currentfil: f,
        //         result: ''
        //     })
        //this.hist()
        this.getwords(this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : set ? c : this.state.keyword)

        if (p !== 0) {

            if (p === 0) {
                this.setState({
                    prev: false
                })
            }
            else {
                this.setState({
                    prev: true
                })
            }
            if (c) {
                if (c.length > 2) {

                    let size = s ? s : this.state.size
                    let cf2 = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : set ? c : this.state.keyword
                    let cf1 = cf2.split('.').join(" ")
                    let cf = this.staradd(cf1).replace(/\//g, "-").replace(/,/g, "")
                    let filter = f ? f : `f[0]=type:submit_for_work&f[1]=type:project&f[2]=type:events`

                    let from = p - this.state.cislength
                    // if (cf1 !== this.props.match.params.id)
                    //     if (set !== 'setfil') {
                    // }
                    console.log(BASE + 'api/search?Keyword=' + cf + '&from=' + from + '&size=' + size + '&' + filter + '&exclude=[' + this.state.cisstring + ']', 'urlax')
                    console.log("calling api in search", this.state.filters.includes('type:submit_for_work'))
                    Axios(BASE + 'api/search?Keyword=' + cf + '&from=' + from + '&size=' + size + '&' + filter + '&exclude=[' + this.state.cisstring + ']', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    })
                        .then((data) => {
                            this.topFunction()
                            if (p === 0 && this.state.filters.includes('type:submit_for_work'))
                                this.getrelfil()
                            console.log(data, 'result')
                            console.log(this.state.result, 'countxx')
                            this.setState({
                                result: data.data.hits.hits,
                                next: false,
                                total: data.data.hits.total.value,
                                loader: false
                                // relfil:data.data.aggregations,
                                // journal:data.data.aggregations.journal_label.buckets,
                                // affiliation:data.data.aggregations.affliations_label.buckets,
                                // authorlist:data.data.aggregations.authors_label.buckets
                            })
                            if (data.data.hits.hits.length === 0) {
                                this.setState({
                                    notxt: "No results found for  "
                                })
                            }
                            else {
                                let page = Number(size) + p - this.state.cislength
                                this.checkpage(cf, f, page, size)
                                this.setState({
                                    notxt: ''
                                })
                            }
                        })
                        .catch((err) => {
                            console.log('err')
                        })
                    Axios(BASE + 'api/search?Keyword=' + cf + '&from=' + from + '&size=' + size + '&' + `f[0]=type:project` + '&exclude=[' + this.state.cisstring + ']', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    })
                        .then(project => {
                            console.log("project found", project.data)
                            this.setState({
                                projectTotal: project.data.hits.total.value,
                            })
                        })
                        .catch((err) => {
                            console.log('err')
                        })
                    Axios(BASE + 'api/search?Keyword=' + cf + '&from=' + from + '&size=' + size + '&' + `f[0]=type:events` + '&exclude=[' + this.state.cisstring + ']', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    })
                        .then(event => {
                            console.log("project found", event.data)
                            this.setState({
                                eventTotal: event.data.hits.total.value,
                            })
                        })
                        .catch((err) => {
                            console.log('err')
                        })
                }
                else {
                    this.setState({
                        result: '',
                        notxt: ''
                    })

                }

            }
        }
        else {
            this.cisresult(c, f, p, s, set)
        }
        // }

    }

    langSelected(e) {
        console.log(e)
        let tmp;
        if (e == "ara") {
            tmp = true;
        }
        else
            tmp = false;
        console.log(tmp)
        this.setState({
            search_menu_opt: undefined
        })
        this.setState({
            search_menu_opt: tmp
        })
    }

    selectall(content) {
        if (!this.state.selectall) {
            let i = 0;
            let exportid = []
            for (i = 0; i < content.length; i++) {
                exportid.push(content[i]._source.nid[0])
            }
            this.setState({
                exportid: exportid,
                selectall: true
            })
        }
        else
            this.setState({
                exportid: [],
                selectall: false
            })

    }

    checkpage(cf, filters, page, size) {
        console.log(BASE + 'api/search?Keyword=' + cf + '&from=' + page + '&size=' + size + '&' + filters, 'checkpage')
        // Axios(BASE+'/api/search?type=submit_for_work&Keyword='+cf+'&'+filters+'&page='+page, {
        Axios(BASE + 'api/search?Keyword=' + cf + '&from=' + page + '&size=' + size + '&' + filters + '&exclude=[' + this.state.cisstring + ']', {

            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                if (data.data.hits.hits.length === 0) {
                    this.setState({
                        next: false
                    })
                }
                else {
                    console.log('searchapinexttrue', data)

                    this.setState({
                        next: true
                    })
                }

            })
            .catch((err) => {
                console.log('not found')
            })
    }

    checkcis(nid) {
        let dt = this.state.cisnid.indexOf(nid)
        if (dt > -1) {
            return true
        }
        else {

            return false

        }
    }

    selectbgc(content) {
        let dt = this.state.search_filters_arr.indexOf(content)
        if (dt > -1) {
            return true
        }
        else {

            return false

        }
    }
    setType(type) {
        if (this.state.filters === `f[0]=type:${type}`) {
            this.setState({
                filters: ""
            })
            this.props.history.push({ search: `` })
        }
        else {
            this.search(this.state.keyword, `f[0]=type:${type}`, 0, 20)
            this.props.history.push({ search: `?type=${type}` })
            this.setState({
                filters: `f[0]=type:${type}`
            })
        }
    }
    setFilter(id) {
        console.log('filterset', id)
        console.log("filterarray", this.state.search_filters_arr)
        this.setState({
            start: 0,
            loader: true,
            next: false,
            filterset: id
        })
        this.topFunction()
        let srch_arr = this.state.search_filters_arr;
        if (this.state.search_filters_arr && this.state.keyword) {
            if (this.state.search_filters_arr.length > 0) {
                let dt = this.state.search_filters_arr.indexOf(id)
                if (dt > -1) {
                    srch_arr.splice(dt, 1);
                    if (new URLSearchParams(this.props.location.search).get("type")) {
                        console.log("filter found", new URLSearchParams(this.props.location.search).get("type"))
                        this.props.history.push({
                            search: '',
                        });

                    }
                }
                else {
                    srch_arr.push(id)
                }
            }
            else {
                srch_arr = this.state.search_filters_arr
                srch_arr.push(id)
            }
            if (this.state.keyword.length > 2) {
                console.log(this.state.search_filters_arr, this.state.filters, 'xxx')
                let filter_params = [this.state.filter];
                for (let d in srch_arr)
                    // filter_params.push(encodeURIComponent('f['+d+']') + '=' + encodeURIComponent(srch_arr[d]));
                    filter_params.push('f[' + d + ']' + '=' + srch_arr[d]);
                let filters = filter_params.join('&')
                console.log(filters, 'jjj')
                this.setState({
                    filters: filters
                })
                let fl = this.state.filter ? this.state.filter : ''
                let cf = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword
                this.search(cf, filters, 0, this.state.size)
            }
            else {
                this.setState({
                    result: ''
                })
            }
            if (this.state[id]) {
                console.log('1')
                this.setState({
                    [id]: !this.state[id],
                })

            }
            else {
                console.log('2')
                this.setState({
                    [id]: true,
                })
            }
        }
        else {
            this.fillalert("Enter atleast 3 characters")
        }
    }

    sizechange(e) {
        this.setState({
            size: Number(e.target.value),
            selectall: false,
            exportid: [],
            loader: true,
        })
        this.search(this.state.keyword, this.state.filters, 0, e.target.value)
    }

    fn(key, e, array, type) {
        if (e)
            this.setState({
                [e.target.name]: e.target.value
            })
        let apis = array

        let toSearch = key ? key : e.target.value; // Will check if title have text 'key'

        let result = apis.filter(o => o.key.toLowerCase().replace(/[^\w\s]/gi, '').includes(toSearch.toLowerCase().replace(/[^\w\s]/gi, '')));
        this.setState({
            [type]: result
        })
        console.log(apis, result, 'filter');
    }

    checkjournal() {
        if (this.state.search_filters_arr.length === 1) {
            return true
        }
        else {
            if (this.state.search_filters_arr.indexOf("publications:Articles") != -1) {
                return true
            }
            else {
                return false
            }
        }
    }

    high2(strg) {
        let keyarr = []
        var keyarr2 = this.state.highwords
        console.log(keyarr2, "regex3")
        var rep = 'abbr onclick=""'
        for (let i = 0; i < keyarr2.length; i++) {
            if (keyarr2[i] !== "")
                // if (keyarr2[i].includes('"'))
                //     keyarr.push('\\b' + keyarr2[i].replace(/,/g, "").replace(/[()]/g, '').split('.').join(" ").replace(/["]+/g, '') + '\\b')
                // else
                keyarr.push(keyarr2[i].replace("abbr", rep).replace(/,/g, "").replace(/[()]/g, '').split('.').join(" ").replace(/["]+/g, '').replace(/[\u201C\u201D]/g, '"'))
        }
        console.log(keyarr.join('|'), "high223")
        var querystr = keyarr.join("|");
        var result = strg
        var reg = new RegExp(querystr, 'gi');
        //var reg = new RegExp('([^a-zA-Z0-9_-]|^)' + querystr + '(?![a-zA-Z0-9_-])', 'g')
        console.log(reg, 'regex');
        var final_str = result.replace(reg, function (str) { return '<mark>' + str + '</mark>' });
        return final_str
    }

    hist() {
        this.props.history.push({
            pathname: '/search/' + this.state.keyword,
            search: '?filter=' + this.state.filters + '&adv=' + this.state.advancearray.length !== 0 ? this.state.advancearray : null
        })
    }

    storenext(index, cis) {
        if (localStorage.getItem('expiryref'))
            this.checkexpiry('open')
        let cf2 = this.state.advancearray.length !== 0 && this.state.advancekey ? this.state.advancekey : this.state.keyword
        let cf1 = cf2.split('.').join(" ")
        // alert(cis)
        let cf = this.staradd(cf1).replace(/[()]/g, '').replace(/\//g, "-").replace(/,/g, "")
        localStorage.setItem('indexof', JSON.stringify(cis ? cis : this.state.from + index - this.state.cislength))
        localStorage.setItem('from', JSON.stringify(this.state.from))
        localStorage.setItem('filterof', JSON.stringify(this.state.filters))
        localStorage.setItem('keyword', cf)
    }

    gethighlight(data) {
        return <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={this.state.highwords}
            autoEscape={true}
            textToHighlight={data}
        />
    }
    checkDefaultFilterCombination() {
        let filters = this.state.filters
        console.log("checking filter", filters)
        let type = new URLSearchParams(this.props.location.search).get("type")
        if (type) {
            if (type === "events" || type === "project") {
                this.setState({
                    filterhide: "block_pub"
                })
                return "block_pub"
            }
            else {
                this.setState({
                    filterhide: "block_other"
                })
                return "block_other"
            }
        }
        else if (filters.length) {
            if (filters !== "f[0]=type:submit_for_work&f[1]=type:project&f[2]=type:events") {
                if (filters.includes("events") || filters.includes("project")) {
                    this.setState({
                        filterhide: "block_pub"
                    })
                    return "block_pub"
                }
                else if (filters.includes("publications:")) {
                    this.setState({
                        filterhide: "block_other"
                    })
                    return "block_other"
                }
            }

        }
        else {
            this.setState({
                filterhide: ""
            })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.filters !== this.state.filters) {
            console.log("checking filter details", this.checkDefaultFilterCombination())
        }
    }
    render() {
        console.log(this.state.total, this.state.cislength, "countxxx1")
        if (this.state.redirect) {
            return <Redirect to={'/search/' + this.state.keyword} />;
        }

        return (
            <div className='searchpage'>
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                {this.state.fillalert ? <div className={this.state.filltext === 'Mail Sent' ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext}</div> : ''}

                <Header langSelected={(e) => this.langSelected(e)} />
                {this.state.loader ? <Loader color="#165e84" loaded={false} className="spinner" /> : ''}
                <div className="main-content listing">

                    <div className="container newsrea">
                        <div className='top-contents'>
                            <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/search'>Search</Link></div>
                        </div>
                        {this.state.currentid ? <div className="searchheaddiv filter_inner_wrapper">
                            <div>
                                <h1 className="heading">Search Results</h1>
                            </div>

                        </div> : ''}
                        <div className="row" >

                            <div className="region region-content search_inner_container">

                                <div className="filter_block">

                                    <div className="filter_container">



                                        <div className="filter_inner_wrapper">
                                            <div>
                                                <h3 className="title">
                                                    <div className="filter_key">Result Type</div>
                                                </h3>
                                                <div className="filter_inner_wrpr">
                                                    {this.state.relfil && this.state.relfil.type_of_work.buckets.length !== 0 && this.state.filterhide !== "block_pub" ? this.state.relfil.type_of_work.buckets.map((val_arr, ind) => {
                                                        return (
                                                            <div className="selct_container" >
                                                                <div className="selct_box" onClick={() => this.setFilter('publications:' + val_arr.key)} style={{ backgroundColor: this.selectbgc('publications:' + val_arr.key) ? '#165E84' : '' }}></div>
                                                                <div className="selct_value" onClick={() => this.setFilter('publications:' + val_arr.key)} style={{ color: this.selectbgc('publications:' + val_arr.key) ? '#165E84' : '' }}>{val_arr.key}</div>
                                                            </div>
                                                        )
                                                    }) : ''}
                                                    {this.state.projectTotal && this.state.filterhide !== "block_other" ? <div className="selct_container">
                                                        <div className="selct_box" onClick={() => this.setFilter('type:' + "project")} style={{ backgroundColor: this.selectbgc('type:' + "project") ? '#165E84' : '' }}></div>
                                                        <div className="selct_value" onClick={() => this.setFilter('type:' + "project")} style={{ color: this.selectbgc('type:' + "project") ? '#165E84' : '' }}>Project</div>
                                                    </div> : ""}
                                                    {this.state.eventTotal && this.state.filterhide !== "block_other" ? <div className="selct_container">
                                                        <div className="selct_box" onClick={() => this.setFilter('type:' + "events")} style={{ backgroundColor: this.selectbgc('type:' + "events") ? '#165E84' : '' }}></div>
                                                        <div className="selct_value" onClick={() => this.setFilter('type:' + "events")} style={{ color: this.selectbgc('type:' + "events") ? '#165E84' : '' }}>Events</div>
                                                    </div> : ""}

                                                </div>

                                            </div>

                                        </div>



                                        {this.state.journal && this.state.relfil.journal_label.buckets.length !== 0 ?
                                            !this.selectbgc('type:project') && !this.selectbgc('type:events') ?
                                                <div className="filter_inner_wrapper">
                                                    <div>
                                                        <div className="filterheaddiv">
                                                            <h3 className="title">
                                                                <div className="filter_key">Journals</div>
                                                            </h3>
                                                            <img onClick={() => this.setState({ journalsearch: !this.state.journalsearch })} src={search} alt='search' />
                                                        </div>
                                                        {this.state.journal && this.state.journalsearch ?
                                                            <div className='mini_search'>
                                                                <input placeholder='search' type="text" name="journkey" value={this.state.journkey} size="40" minLength="3" maxlength="60" onChange={e => this.fn('', e, this.state.relfil.journal_label.buckets, 'journal')} />

                                                            </div> : ''}
                                                        <div className="filter_inner_wrpr">
                                                            {this.state.journal ? this.state.journal.map((val_arr, ind) => {
                                                                return (
                                                                    <div className="selct_container" >
                                                                        <div className="selct_box" onClick={() => this.setFilter('journal:' + val_arr.key)} style={{ background: this.selectbgc('journal:' + val_arr.key) ? '#165E84' : '' }}></div>
                                                                        <div className="selct_value" onClick={() => this.setFilter('journal:' + val_arr.key)} style={{ color: this.selectbgc('journal:' + val_arr.key) ? '#165E84' : '' }}>{val_arr.key}</div>
                                                                    </div>
                                                                )
                                                            }) : ''}

                                                        </div>

                                                    </div>

                                                </div>

                                                : '' : ""}

                                        {this.state.authorlist && this.state.relfil.authors_label.buckets.length !== 0 ?
                                            <div className="filter_inner_wrapper">
                                                <div>
                                                    <div className="filterheaddiv">
                                                        <h3 className="title">
                                                            <div className="filter_key">Authors</div>
                                                        </h3>
                                                        <img onClick={() => this.setState({ authorsearch: !this.state.authorsearch })} src={search} alt='search' />
                                                    </div>
                                                    {this.state.authorlist && this.state.authorsearch ?
                                                        <div className='mini_search'>
                                                            <input placeholder='search' type="text" name="authkey" value={this.state.authkey} size="40" minLength="3" maxlength="60" onChange={e => this.fn('', e, this.state.relfil.authors_label.buckets, 'authorlist')} />

                                                        </div> : ''}
                                                    <div className="filter_inner_wrpr">
                                                        {this.state.authorlist ? this.state.authorlist.map((val_arr, ind) => {
                                                            if (val_arr.key !== "Others" && val_arr.key !== "Anonymous" && val_arr.key !== "NotAvailable")
                                                                return (
                                                                    <div className="selct_container" >
                                                                        <div className="selct_box" onClick={() => this.setFilter('author:' + val_arr.key)} style={{ background: this.selectbgc('author:' + val_arr.key) ? '#165E84' : '' }}></div>
                                                                        <div className="selct_value" onClick={() => this.setFilter('author:' + val_arr.key)} style={{ color: this.selectbgc('author:' + val_arr.key) ? '#165E84' : '' }}>{val_arr.key}</div>
                                                                    </div>
                                                                )
                                                        }) : ''}

                                                    </div>

                                                </div>

                                            </div>

                                            : ''}

                                    </div>

                                </div>
                                <div className="search_block">
                                    <div className="listings">
                                        <div></div>
                                        <div className="input_sec">
                                            <input type="text" id="edit-keys" name="keyword" value={this.state.keyword} size="40" minLength="3" maxlength="255" className="form-text" onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} />
                                            <img onClick={e => { this.handleChange(e); this.search(this.state.keyword, this.state.filters, 0, this.state.size); this.handleSubmit() }} src={search} alt='search' />
                                        </div>
                                    </div>
                                    <div className='search-under'>
                                        {this.state.result && this.state.highwords && this.state.result.length != 0 && this.state.cisnid ?
                                            this.state.total || this.state.currentid && this.state.cislength ?
                                                <div className="totalfound">
                                                    <div>
                                                        {this.state.total || this.state.cislength ? this.state.total + this.state.cislength + '\xa0' : 0 + '\xa0'}
                                                    </div>
                                                    Results found for
                                                    <div>
                                                        {this.state.currentid ? '\xa0' + this.state.currentid : "NIL"}
                                                    </div>
                                                </div> : '' : ''}
                                        <div className='search-tab-under'>
                                            <div onClick={() => this.openadvance()} className="advancesearch">
                                                Advanced search
                                            </div>
                                            {this.state.advance ? this.state.advancearray.map((value, index) =>
                                                <div className="advancetab">
                                                    <div>
                                                        <input onKeyPress={(e) => this._handleKeyPress2(e)} value={this.state.advancearray[index]} name="advancekey" onChange={(e) => this.keychange(e, index)} />
                                                        <select name="advanceopt" onChange={(e) => this.keychange(e, index)} value={this.state.advanceopt[index]}>
                                                            <option value="AND">AND</option>
                                                            <option value="OR">OR</option>
                                                            <option value="NOT">NOT</option>
                                                        </select>
                                                        <div style={{ visibility: this.state.advancearray[index] != "" && this.state.advanceopt[index + 1] ? "hidden" : '' }} onClick={() => this.addadvancearray(index)}>
                                                            +
                                                        </div>


                                                        <div onClick={() => this.deladvacnearray(index)}>
                                                            -
                                                        </div>
                                                    </div>

                                                </div>
                                            ) : ''}
                                        </div>

                                    </div>
                                    {this.state.result && this.state.highwords && this.state.result.length != 0 && this.state.cisnid ?
                                        this.state.total || this.state.currentid && this.state.cislength ?
                                            <div className="totalfound mobilecount">
                                                <div>
                                                    {this.state.total + this.state.cislength + '\xa0'}
                                                </div>
                                                Results found for
                                                <div>
                                                    {'\xa0' + this.state.currentid}
                                                </div>
                                            </div> : '' : ''}



                                    <div className="countsection">
                                        {/* <div style={{ backgroundColor: "#5d1818" }} className="selct_container" >
                                                <div className="selct_value" >All</div>
                                                <div className="selct_value" >{this.state.total}</div>
                                            </div> */}
                                        {this.state.relfil && this.state.total && this.state.currentid ? this.state.relfil ? this.state.filterhide !== "block_pub" ? this.state.relfil.type_of_work.buckets.map((val_arr, ind) => {
                                            return (
                                                <div className="selct_container" >
                                                    <div className="selct_value select-count no" >{val_arr.doc_count}</div>
                                                    <div className="selct_value select-count" >{val_arr.key}</div>
                                                </div>
                                            )
                                        }) : '' : "" : ''}
                                        <div className="selct_container" style={{ display: this.state.projectTotal && this.state.filterhide !== "block_other" ? "" : "none" }} >
                                            <div className="selct_value select-count no" >{this.state.projectTotal}</div>
                                            <div className="selct_value select-count" >Project</div>
                                        </div>
                                        <div className="selct_container" style={{ display: this.state.eventTotal ? "" : "none" }} >
                                            <div className="selct_value select-count no" >{this.state.eventTotal}</div>
                                            <div className="selct_value select-count" >Events</div>
                                        </div>
                                    </div>
                                    <div style={{ justifyContent: this.state.login ? '' : 'flex-end' }} className="searchunder">
                                        {this.state.result && this.state.login && this.state.result.length != 0 ?
                                            <div>
                                                <div>
                                                    Results per page
                                                </div>
                                                <select onChange={(e) => this.sizechange(e)} name="size" value={this.state.size}>
                                                    <option value="20">20</option>
                                                    <option value="50">50</option>
                                                </select>
                                            </div>
                                            : ''}
                                        {this.state.result && this.state.login && this.state.result.length != 0 ?
                                            <div className="impexp">
                                                <div onClick={() => this.printTest2("save")}>Save</div>
                                                <div onClick={() => this.printTest2("print")}>Print</div>
                                                <div onClick={() => this.openpopmail()}>Email</div>
                                            </div> : ''}
                                    </div>

                                    {this.state.mailpop ?
                                        <div className="mailpop">
                                            <input value={this.state.mailpdf} onChange={(e) => this.exportmail(e)} name="mailpdf" />
                                            <button onClick={() => this.printTest2("mail", this.state.mailpdf)}>Send</button>
                                        </div>
                                        : ''}

                                    {this.state.login && this.state.result && this.state.result.length != 0 ? <div className="selectalldiv">
                                        <div className="selectall">
                                            <div
                                                style={{ backgroundColor: this.state.selectall ? '#165e84' : '' }}
                                                onClick={() => this.selectall(this.state.result)} className="selct_box">
                                            </div>
                                            <div>Select All</div>
                                        </div>
                                    </div>
                                        : ''}

                                    <ol className="search-results node-results">

                                        {this.state.result && this.state.highwords && this.state.result.length != 0 && this.state.cisnid ? this.state.result.map((result, index) => {
                                            return (
                                                <div style={{ backgroundColor: this.state.start === 0 ? index < this.state.cisnid.length ? '#cbf1f569' : '' : '' }} className="searchresultdiv">
                                                    {this.state.login ?
                                                        <div
                                                            style={{ backgroundColor: this.checkexport(result._source.nid[0]) ? '#165e84' : 'white' }}
                                                            onClick={() => this.exportid(result._source.nid[0])} className="selct_box">
                                                        </div> : ''}
                                                    <div style={{ width: this.state.login ? '' : '100%' }}>
                                                        <li>
                                                            <div className="result_links">
                                                                {result._source.publications_label ? <Link target="_blank" onClick={() => this.storenext(index, this.state.start === 0 ? index < this.state.cisnid.length ? index - this.state.cisnid.length : false : false)} to={this.goto2(result._source.nid[0], result._source.publications_label[0], result._source.title[0])}>{ReactHtmlParser(this.high2(result._source.title[0]))}</Link>
                                                                    : result._source.type[0] == "project" ? <Link to={`/projectdetails/${result._source.nid[0]}`}>{ReactHtmlParser(this.high2(result._source.title[0]))}</Link> : <Link to={`/event_desc/${result._source.title[0]}/${result._source.nid[0]}`}>{ReactHtmlParser(this.high2(result._source.title[0]))}</Link>} </div>

                                                            <p style={{ color: '#b0b0b0', textTransform: "capitalize" }}>
                                                                {result._source.publications_label ? result._source.publications_label[0] === "Book Chapters" ? "Chapters" : result._source.publications_label[0] :
                                                                    result._source.type[0]
                                                                }
                                                            </p>
                                                        </li>
                                                        <div className='searchauthors'>
                                                            {result._source.author_label ? result._source.author_label.map((author, index) => {
                                                                return <div className="author">
                                                                    {ReactHtmlParser(this.high2(author))}                                                                </div>
                                                            }) : ''}
                                                        </div>
                                                        <div className='searchauthors'>
                                                            {result._source.lead_project_investigator ? result._source.lead_project_investigator.map((author, index) => {
                                                                return <div className="author">
                                                                    {ReactHtmlParser(this.high2(author))}
                                                                </div>
                                                            }) : ""}
                                                            {result._source.other_project_investigators ? result._source.other_project_investigators.map((author, index) => {
                                                                return <div className="author">
                                                                    {ReactHtmlParser(this.high2(author))}
                                                                </div>
                                                            }) : ""}
                                                        </div>
                                                        {result._source.event_organising_institution ? result._source.event_organising_institution.map((author, index) => {
                                                            return <div className="author">
                                                                {ReactHtmlParser(this.high2(author))}
                                                            </div>
                                                        }) : ""}
                                                        {result._source.journal_label && result._source.journal_label.length != 0 ? result._source.journal_label.map((author, index) => {
                                                            return <div className="author">
                                                                {ReactHtmlParser(this.high2(author))}
                                                            </div>
                                                        }) : ''}


                                                    </div>
                                                </div>
                                            )
                                        }) : this.state.notxt ?
                                            <ul>
                                                <li id="nofound">{this.state.notxt}<span>{this.state.currentid}</span></li>
                                                <li id="nofound">Please confirm the spelling of your search word.</li>

                                            </ul> : ''}

                                    </ol>
                                    {this.state.result && (this.state.prev || this.state.next) ?

                                        <ul className="pagination">
                                            <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                                                <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                                            <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                                        </ul>

                                        : ''}



                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="button-responsive">
                    <button onClick={() => this.setState({
                        fpopup: !this.state.fpopup
                    })} class="filter">Filter</button>
                    <i class="filter-icon"></i>
                </div>
                {/* MObile FIlter */}
                <div className='mobile_filter' style={{ display: this.state.fpopup ? '' : 'none' }}>
                    <div className='mobile_filter_head' ><div>Filters</div><div onClick={() => this.setState({
                        fpopup: !this.state.fpopup
                    })}>X</div></div>
                    <div className="filter_block">
                        <div className="filter_container">

                            {this.state.relfil && this.state.relfil.type_of_work.buckets.length !== 0 ?

                                <div className="filter_inner_wrapper">
                                    <div>
                                        <h3 className="title">
                                            <div className="filter_key">Result Type</div>
                                        </h3>
                                        <div className="filter_inner_wrpr">
                                            {this.state.relfil ? this.state.relfil.type_of_work.buckets.map((val_arr, ind) => {
                                                return (
                                                    <div className="selct_container" >
                                                        <div className="selct_box" onClick={() => this.setFilter('publications:' + val_arr.key)} style={{ backgroundColor: this.selectbgc('publications:' + val_arr.key) ? '#165E84' : '' }}></div>
                                                        <div className="selct_value" onClick={() => this.setFilter('publications:' + val_arr.key)} >{val_arr.key + '(' + val_arr.doc_count + ')'}</div>
                                                    </div>
                                                )
                                            }) : ''}
                                            <div className="selct_container">
                                                <div className="selct_box" style={{ backgroundColor: new URLSearchParams(this.props.location.search).get("type") ? new URLSearchParams(this.props.location.search).get("type") === "project" ? '#165E84' : "" : '' }}></div>
                                                <div className="selct_value">Project</div>
                                            </div>
                                            <div className="selct_container">
                                                <div className="selct_box" style={{ backgroundColor: new URLSearchParams(this.props.location.search).get("type") ? new URLSearchParams(this.props.location.search).get("type") === "events" ? '#165E84' : "" : '' }}></div>
                                                <div className="selct_value">Events</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                : ''
                            }
                            {this.state.relfil && this.state.relfil.type_of_work.buckets.length !== 0 ?
                                <div className='filter_border'></div>
                                : ''}



                            {this.state.journal && this.state.relfil.journal_label.buckets.length !== 0 ?

                                <div className="filter_inner_wrapper">
                                    <div>
                                        <h3 className="title">
                                            <div className="filter_key">Journals</div>
                                        </h3>
                                        {this.state.journal ?
                                            <div className='mini_search'>
                                                <input placeholder='search' type="text" name="journkey" value={this.state.journkey} size="40" minLength="3" maxlength="60" onChange={e => this.fn('', e, this.state.relfil.journal_label.buckets, 'journal')} />
                                                <img onClick={() => this.fn(this.state.journkey, '', this.state.relfil.journal_label.buckets, 'journal')} src={search} alt='search' />

                                            </div> : ''}
                                        <div className="filter_inner_wrpr">
                                            {this.state.journal ? !this.selectbgc('type:project') ? this.state.journal.map((val_arr, ind) => {
                                                return (
                                                    <div className="selct_container" >
                                                        <div className="selct_box" onClick={() => this.setFilter('journal:' + val_arr.key)} style={{ background: this.selectbgc('journal:' + val_arr.key) ? '#165E84' : '' }}></div>
                                                        <div className="selct_value" onClick={() => this.setFilter('journal:' + val_arr.key)} >{val_arr.key}</div>
                                                    </div>
                                                )
                                            }) : "" : ''}

                                        </div>

                                    </div>

                                </div>

                                : ''}

                            {this.state.journal && this.state.relfil.journal_label.buckets.length !== 0 ? <div className='filter_border'></div> : ''}

                            {this.state.authorlist && this.state.relfil.authors_label.buckets.length !== 0 ?
                                <div className="filter_inner_wrapper">
                                    <div>
                                        <h3 className="title">
                                            <div className="filter_key">Authors</div>
                                        </h3>
                                        {this.state.authorlist ?
                                            <div className='mini_search'>
                                                <input placeholder='search' type="text" name="authkey" value={this.state.authkey} size="40" minLength="3" maxlength="60" onChange={e => this.fn('', e, this.state.relfil.authors_label.buckets, 'authorlist')} />
                                                <img onClick={() => this.fn(this.state.authkey, '', this.state.relfil.authors_label.buckets, 'authorlist')} src={search} alt='search' />

                                            </div> : ''}
                                        <div className="filter_inner_wrpr">
                                            {this.state.authorlist ? this.state.authorlist.map((val_arr, ind) => {
                                                return (
                                                    <div className="selct_container" >
                                                        <div className="selct_box" onClick={() => this.setFilter('author:' + val_arr.key)} style={{ background: this.selectbgc('author:' + val_arr.key) ? '#165E84' : '' }}></div>
                                                        <div className="selct_value" onClick={() => this.setFilter('author:' + val_arr.key)} >{val_arr.key}</div>
                                                    </div>
                                                )
                                            }) : ''}
                                        </div>
                                    </div>
                                </div>
                                : ''}
                            <div class="button-responsive">
                                <button onClick={() => this.setState({
                                    fpopup: !this.state.fpopup
                                })} class="filter">Apply Filter</button>
                                <i class="filter-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='search_footer'><Footer /></div>
            </div>
        )
    }

}


export default Search;
